export default class ArticleCommentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.comment = data.comment || '';
    this.created = new Date(data.created);
  }
}
